/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LineItemCapability {
    CHECKOUT_LINE_ITEM_REMOVE = 'checkout_line_item:remove',
}
